//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 27.10.2015.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngScrollpane', srsngScrollpane);

    function srsngScrollpane($timeout) {

        return {
            restrict: 'A',
            scope: {
                api: '=srsngScrollpane'
            },
            controller: controller,
            link: link
        };

        function controller() {
            // this is intentional override
        }

        function link(scope, element, attrs) {

            init();
            function update() {
                element.perfectScrollbar('update');
            }

            function init() {

                element.addClass('scroll-pane');

                element.perfectScrollbar({
                    minScrollbarLength: 10
                });

                $(window).on('resize.scrollpane', function () {
                    update();
                });

                if (scope.api) {
                    scope.api.update = update;
                }
            }
        }
    }
})();
